import createStyles from '@material-ui/core/styles/createStyles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { Theme } from '@material-ui/core/styles/createTheme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      textAlign: 'center',
    },
    done: {
      textAlign: 'right',
    },
    progress: {
      margin: theme.spacing(4, 0),
      '& .MuiGrid-item': {
        padding: theme.spacing(1),
      },
    },
    progressBar: {
      padding: '0',
      width: '100%',
      height: '6px',
      position: 'relative',
      backgroundColor: theme.palette.grey['300'],
      '& div': {
        height: '100%',
        position: 'absolute',
        background: theme.palette.primary.main,
      },
    },
    currentStep: {
      textAlign: 'center',
      lineHeight: '16px',
      color: theme.palette.grey['600'],
      '& .MuiCircularProgress-root': {
        marginRight: theme.spacing(1),
      },
    },
    errors: {
      '& p': { color: theme.palette.error.main },
      '& ul': {
        padding: theme.spacing(2, 2, 2, 4),
        border: 'solid #ccc 1px',
        backgroundColor: theme.palette.grey['100'],
        color: theme.palette.grey['600'],
      },
      '& span': {
        fontSize: '80%',
      },
    },
    actions: {
      justifyContent: 'center',
      alignItems: 'center',
      margin: theme.spacing(4,0,2,0),
    },
  }),
);

export default useStyles;
